/**
 * Documents: a Notion/Affine-style rich-text document space. Users organize
 * documents into a drag-and-drop folder tree (rendered as the panel's sidebar),
 * open several in tabs, and export to PDF. Unlike Task Manager (a full-page
 * panel with no sidebar), Documents KEEPS the sidebar — the folder tree lives
 * there (see App.js's `activeTab === 'documents.panel'` branch and
 * DocumentsSidebar.js) while each open document renders as a host tab
 * (DocumentEditorTab.js) via the shared multi-tab system.
 *
 * Content is read/written directly by the frontend through the `records`
 * capability (extension_documents), so every folder/document rides the normal
 * local → SQLite → cloud/team sync path for free — no native code, no new
 * migrations. The guest iframe (entry.js) is a no-op, kept only to satisfy the
 * extension registration contract (mirrors task-manager).
 */
export const documentsManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.documents',
  name: 'Documents',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'file-text',
  engines: { apibooSdk: '^1.0.0' },
  // HOST-RENDERED, not sandboxed: the panel above is a first-party React
  // component calling Tauri directly, so `permissions: []` means "declares no
  // GUEST capabilities", not "has no access". Settings reads this flag to say
  // that plainly instead of showing an empty permission list that implies a
  // control the user does not have — see EXT-05.
  hostRendered: true,
  permissions: [],
  // Rollout switches read by documentsFlags.js (card 5.5). `documents.scopes`
  // = user-defined document workspaces; OFF until the backend's docscope
  // support (cards 4.1 + 4.2) is deployed on both regions — an undeployed
  // server would store the records but not count them against the plan.
  flags: { 'documents.scopes': false },
  contributes: {
    activityBar: [
      { id: 'documents.activity', title: 'Documents', icon: 'file-text', order: { after: 'task-manager.activity' } },
    ],
    panels: [{ id: 'documents.panel', activityBarId: 'documents.activity', title: 'Documents' }],
    settings: [],
  },
};
